export default (validation, data, action) => {
  const details = {}

  for (const key of validation) {
    const value = data[key]
    if (value === undefined) {
        if (process.env.NODE_ENV !== 'production') {
            console.info(`Error in logtrace details on action: ${action.id} - ${action.description} - ${key}`)
        }

        continue
    }

    details[key] = value
  }

  return details
}



// WEBPACK FOOTER //
// ./src/services/logTrace/formatDetails.js